module.exports = __webpack_public_path__ + "static/media/248131HD_WhiteNoise.1c4bdecf.mp4";